const $ = require('jquery');
const _ = require('lodash');
const Q = require('q');
const dict = require('./dictionary.js');
const server = require('server');
const appModel = require('./model.js');
const yaCounter = require('yandex-counter');

function controller (options) {
	options = _.defaultsDeep({}, options, {
		productName: 'Null',
		dict: dict(),
		
	});

	function submitForm ()	{
		
		if (!model.ValidationGroup().isValid()){
			model.ValidationGroup().showAllMessages(true);
			return;
		}

		model.BlockButton(true);
		server.any.api.insuranceApplication({ data: model._toJS() })
			.then(function (data){
				model.BlockButton(false);

				return data;
			})
			.then(function (data) {
				const response = data.responseJSON;
				if (response.Status === 'Success') {
					switch (options.productName) {
						case 'KaskoAutumn':
							yaCounter.reachGoal('short_form_kasko_landing_OK');
							break;
						case 'Kasko':
							yaCounter.reachGoal('short_form_kasko_OK');
							break;
						case 'Building':
							yaCounter.reachGoal('short_form_ifl_akcia_OK');
							break;
					}
					model.Module('Success');
				} else {
					model.Module('Error');
				}
			})
			.done();
	}

	function File (id, name)	{
		return {
			ID: id,
			Name: name,
		};
	}

	options.fileuploadOpt = {
		url: '/api/file/SaveTemporaryFile',
		forceIframeTransport: true,
		dataType: 'json',
		formAcceptCharset: 'utf-8',
		done: function (e, data) {
			$.map(data.files, function (f) {
				const res = data.response().result;
				const ok = res && res.Status === 'Success';
				if (ok) {
					model.AttachedFiles([
						new File($.map(res.Data, (v, k) => k)[0], f.name),
					]);
					$('#applicationForm .AttachedFileError').hide();
				}
			});
		},
		fail: function () {
			$('#applicationForm .AttachedFileError').show();
		},
	};


	const product = options.dict.Products[options.productName]
			|| options.dict.Products.Null;

	if (!product.isNull) {
		Q.promise(function (resolve) {
			$(resolve);
		}).then(function () {
			return server.any.api.offices.getAllRegions();
		})
			.then(function (response) {
				const regions = response.responseJSON.Data;
				model.RegionsList(regions);
			});
	}

	options.product = product;
	options.submitForm = submitForm;

	const model = appModel().init(options);
	return { model: model };
}

module.exports = controller;
